module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-190.deeab990.svg";